import { render } from "./ModelApartmentsPage.vue?vue&type=template&id=266b90db"
import script from "./ModelApartmentsPage.vue?vue&type=script&lang=js"
export * from "./ModelApartmentsPage.vue?vue&type=script&lang=js"

import "./ModelApartmentsPage.vue?vue&type=style&index=0&id=266b90db&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__